"use strict";
import { Dropzone } from "./src/Dropzone.dev.js";
import { defineElement } from "@spectrum-web-components/base/src/define-element.js";
defineElement("sp-dropzone", Dropzone);
//# sourceMappingURL=sp-dropzone.dev.js.map
